import React from "react";
import SC from "./style";
import { Breadcrumbs } from "InnoUI/components";
import { useLocation } from "react-router";

const Roadmap = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Site Information", href: "/admin-settings/site-information" },
  ];

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={() => alert("clicked")}
      />
      <SC.BodyContainer>
        <p>saafsdf</p>
      </SC.BodyContainer>
    </>
  );
};

export default Roadmap;
